import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import Select from 'react-select'
import { generateOptions } from './utils/QuoteStatus'


class QuoteStatusSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            options: this.props.options || generateOptions(props.intl),
            selectedOptions: this.props.value || [],
            multi: !isNaN(this.props.multi) ? this.props.multi : true,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.getAllowedStatuses = this.props.getAllowedStatuses || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        const allowedStatuses = this.getAllowedStatuses()
        if (allowedStatuses && allowedStatuses.length > 0) {
            this.setState({
                options: this.state.options.filter(op => allowedStatuses.includes(op.value))
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value || []
            })
        }
    }

    handleChange(selectedOptions) {
        this.setState({
            selectedOptions: selectedOptions
        }, () => {
            if (selectedOptions) {
                if (this.state.multi) {
                    this.props.onChange(selectedOptions.map(option => option.value), selectedOptions.map(option => option.label).join(','))
                } else {
                    this.onChange(selectedOptions.value, selectedOptions.label)
                }
            } else {
                this.onChange("", "")
            }
        });
    }

    render() {
        return (
            <Select
                name={this.name}
                searchable={false}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(QuoteStatusSelect)





// WEBPACK FOOTER //
// ./src/quote/statusesselection.component.jsx